export default {
    consignment: {
        vehicle: {
            length: 50
        }
    },
    resource: {
        email: {
            length: 128
        }
    }
};
